import '@styles/pages/cgu.scss';

import { initAnchor } from '@organisms/anchor';

initAnchor();
